import React from 'react';
import '../../styles/main.scss';

export function renderLoading(className = '', canvasClassName = '', pathClassName = '') {
  return (
    <div className={`spinner ${className}`}>
      <svg className={`canvas ${canvasClassName}`} width="55px" height="55px" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
        <circle className={`path ${pathClassName}`} fill="none" cx="27" cy="27" r="24" />
      </svg>
    </div>
  );
}
